import type { Role } from '../auth/types';

/** Where each role lands after signing in. */
export const HOME_ROUTE_FOR_ROLE: Record<Role, string> = {
  buyer: '/',
  investor: '/investor',
  organizer: '/organizer',
  artist: '/artist',
  agency: '/agency',
  venue: '/venue',
  sponsor: '/sponsor',
  admin: '/admin',
  staff: '/admin',
};
